import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fetchData } from '../../../../utils/fetchData';
import { resolveRenderer } from './renderers';

const Elements = ({
  formName,
  stepNumber,
  setStepHeading,
  setNumberOfSteps,
  fieldsValidated,
  setFormFieldSet,
  setStepLabel,
  errors,
  fileUploading,
  setFileUploading,
}) => {
  const [formFields, setFormFields] = useState([]);
  useEffect(() => {
    fetchData(
      `form-steps?filters[formName][$eq]=${formName}&populate[formField][populate][0]=selectOption&populate[formField][populate][1]=fileExtension&populate[formField][populate][2]=description`,
      setFormFields,
      setFormFieldSet,
      setStepLabel,
      setStepHeading,
      setNumberOfSteps,
      stepNumber,
    );
  }, [
    formName,
    setFormFieldSet,
    setStepLabel,
    setStepHeading,
    setNumberOfSteps,
    stepNumber,
  ]);

  const descriptionSetObject = formFields.find(
    (obj) => obj.__component === 'description-set.description-set',
  );

  return (
    <section key={`form-section-${stepNumber}`}>
      <div className="row">
        {formFields.map((item, index) => {
          const Renderer = resolveRenderer(item);
          if (!Renderer) return '';
          return (
            <Renderer
              key={`elements-${item.__component}-${index}`}
              item={item}
              index={index}
              errors={errors}
              fieldsValidated={fieldsValidated}
              fileUploading={fileUploading}
              setFileUploading={setFileUploading}
              descriptionSetObject={descriptionSetObject}
            />
          );
        })}
      </div>
    </section>
  );
};

const { string, number, bool, func, object } = PropTypes;
Elements.propTypes = {
  formName: string,
  stepNumber: number,
  fieldsValidated: bool,
  fileUploading: bool,
  errors: object,
  setStepHeading: func,
  setNumberOfSteps: func,
  setFormFieldSet: func,
  setStepLabel: func,
  setFileUploading: func,
};

export default Elements;
